export default __webpack_public_path__ + "static/media/git.b196f476.svg";